import { createStore, applyMiddleware } from "redux";
import cartReducer from "./Cart/cartReducer";
const logger = (store) => (next) => (action) => {
  const upcomingState = [action].reduce(cartReducer, store.getState());
  if (upcomingState.availableItem.asusVivo < 0) {
    return window.alert("Out of stock :(");
  }
  if (upcomingState.availableItem.dell < 0) {
    return window.alert("Out of stock :(");
  }
  if (upcomingState.availableItem.canon < 0) {
    return window.alert("Out of stock :(");
  }
  if (upcomingState.cartItem.asusVivo < 0) {
    return window.alert("Item can't be less than 0.");
  }
  if (upcomingState.cartItem.dell < 0) {
    return window.alert("Item can't be less than 0.");
  }
  if (upcomingState.cartItem.canon < 0) {
    return window.alert("Item can't be less than 0.");
  }
  if (upcomingState.totalItem < 0) {
    return window.alert("Item can't be less than 0.");
  }

  // pass action
  return next(action);
};
const store = createStore(cartReducer, applyMiddleware(logger));

export default store;
